import {Component, HostBinding, Input, OnChanges} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-production-schedule-item-in-path-group-repeat-indicator]',
  templateUrl: './production-schedule-item-in-path-group-repeat-indicator.component.html',
  styleUrls: ['./production-schedule-item-in-path-group-repeat-indicator.component.scss']
})
export class ProductionScheduleItemInPathGroupRepeatIndicatorComponent implements OnChanges {
  public static minimumAllowedHeight = 54;

  @Input() public quantity: number;
  @Input() public productionScheduleItemMultiplier: number;
  @Input() public cutbarBeforeHeight: number;
  @Input() public cutbarAfterHeight: number;
  @Input() public drawingHeight: number;
  @Input() public totalHeight: number;
  @HostBinding('attr.width') @Input() public width: number;
  @HostBinding('attr.height') public height: number;

  public verticalLineHeight = 0;

  public ngOnChanges(): void {
    this.height = Math.max(this.totalHeight - this.drawingHeight - this.cutbarAfterHeight - this.cutbarBeforeHeight, ProductionScheduleItemInPathGroupRepeatIndicatorComponent.minimumAllowedHeight);

    this.verticalLineHeight = this.height - 32;
  }

  public getQuantityText(): string {
    return `${this.productionScheduleItemMultiplier} x ${this.quantity}`;
  }
}
